import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

import { DateUtil } from '@rp/utils';

import { Validation, DateComparison } from './enums';

export const dateComparisonValidator = (options: {
  dateFormField: string;
  displayDateField: string;
  displayComparisonDate: string;
  comparisonType: DateComparison;
  compareSameDay?: boolean;
}): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null;
    }

    const formGroup = control.parent;
    if (!formGroup) {
      return null;
    }

    const dateFormFieldControl = formGroup.get(options.dateFormField);
    const comparisonDateValue = dateFormFieldControl?.value;
    const currentDateValue = control.value;

    if (!comparisonDateValue) {
      return null;
    }

    const currentDate = DateUtil.toISOStringWithoutTime(new Date(currentDateValue));
    const comparisonDate = DateUtil.toISOStringWithoutTime(new Date(comparisonDateValue));

    const isSameDay = options.compareSameDay ? currentDate === comparisonDate : false;

    const isInvalid =
      (options.comparisonType === DateComparison.NotEarlierThan
        ? currentDate < comparisonDate
        : currentDate > comparisonDate) || isSameDay;

    if (isInvalid) {
      return {
        [options.comparisonType === DateComparison.NotEarlierThan
          ? Validation.DateNotEarlierThan
          : Validation.DateNotLaterThan]: {
          date: options.displayDateField,
          comparisonDate: options.displayComparisonDate,
        },
      };
    } else if (dateFormFieldControl?.errors) {
      delete dateFormFieldControl.errors[Validation.DateNotEarlierThan];
      delete dateFormFieldControl.errors[Validation.DateNotLaterThan];
      if (!Object.keys(dateFormFieldControl.errors).length) {
        dateFormFieldControl.setErrors(null);
      }
    }

    return null;
  };
};
